module.exports = __webpack_public_path__ + "static/media/nft-39.597f07a5.jpg";